module.exports = __webpack_public_path__ + "static/ml-hero-background-crop-wide-7ddde913bfceaddffd856c06fd95f423.jpg";